import history from "utils/history";

export const paths = {
    call: (id) => `/admin/call/${id}`,
    dispatch911Report: (id) => `/admin/dispatch911/${id}`,
    elevatorCompany: {
        list: "/admin/elevatorcompanies",
        add: "/admin/elevatorcompanies/add",
        view: (id) => `/admin/elevatorcompanies/${id}`,
        edit: (id) => `/admin/elevatorcompanies/${id}/edit`,
    },
    elevator: {
        list: "/admin/elevators",
        view: (id) => `/admin/elevators/${id}`,
        add: (customerId, buildingId) => `/admin/elevators/${customerId}|${buildingId}/add`,
        edit: (id) => `/admin/elevators/${id}/edit`,
    },
    building: {
        list: "/admin/buildings",
        view: (id) => `/admin/buildings/${id}`,
        add: (customerId) => `/admin/buildings/${customerId}/add`,
        edit: (id) => `/admin/buildings/${id}/edit`,
    },
    customer: {
        list: "/admin/customers",
        view: (id) => `/admin/customers/${id}`,
        add: "/admin/customers/add",
        edit: (id) => `/admin/customers/${id}/edit`,
    },
    pbxGroup: {
        view: (id) => `/admin/pbxgroups/${id}`,
        add: "/admin/pbxgroups/add",
        edit: (id) => `/admin/pbxgroups/${id}/edit`,
    },
    blockedPhoneNumber: {
        list: "/admin/blockedphonenumbers",
        view: (id) => `/admin/blockedphonenumbers/${id}`,
        add: "/admin/blockedphonenumbers/add",
        edit: (id) => `/admin/blockedphonenumbers/${id}/edit`,
    }
};

export const redirectToPath = (path) => {
    history.push(path);
};

export const goBack = () => {
    history.goBack();
};

export const replacePath = (path) => {
    history.replace(path);
};

